import React from "react";
const Myregister = () => {
  return (
    <>
      <div className="card1 shadow m-1 mt-2 ">
        <div className="row m-1">
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-1 d-flex align-items-center">
            <span className="badge rounded-pill bg-secondary  ">1</span>
            <span className="badge rounded-pill bg-primary  ms-2">
              แก้ไขวัตถุประสงค์
            </span>
            <div
              className="text-primary"
              style={{ fontSize: 16, fontWeight: "bold" }}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-2">
            <div>
              <h6>
                สาขา :<small style={{ fontSize: 14 }}> โรงชิพวัฒนานคร</small>{" "}
              </h6>
            </div>
            <div>
              <h6>
                เลขที่ใบงาน :
                <small style={{ fontSize: 14 }}> 529-651190785</small>
              </h6>
            </div>
            <div />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-2">
            <div>
              <h6>
                ประเภทลูกค้า :
                <small style={{ fontSize: 14 }}> ลูกค้าทั่วไป</small>
              </h6>
            </div>
            <div>
              <h6>
                ชื่อลูกค้า :<small style={{ fontSize: 14 }}> โรงไฟฟ้า 9</small>
              </h6>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-2">
            <div>
              <div>
                <h6>
                  วันที่บันทึก :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:20:23</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้ทำรายการ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-1">
            <span>ข้อมูล</span>
            <div style={{ fontSize: 14 }}>
              <span
                className="badge bg-success"
                style={{ fontSize: 14, cursor: "pointer" }}
              >
                1
              </span>
              <span className="badge badge text-dark">
                {" "}
                <span style={{ fontSize: 14, cursor: "pointer" }} />
              </span>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4  col-lg-3">
            <div>
              <div>
                <h6>
                  วันที่อนุมัติ :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:21:20</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้อนุมัติ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                  <span className="badge rounded-pill bg-warning text-dark ms-2">
             <span className=" mx-2 ">รออนุมัติ</span> 
            </span>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4 col-lg-1  d-flex align-items-center d-flex justify-content-end">
          {/* <span className="text-primary  ">สถานะ</span> */}
           
            <span className="badge rounded-pill text-primary fs-5">
            <i className="bi bi-pencil-square"  style={{ cursor: "pointer" }}></i>
            </span>
          </div>
        </div>
      </div>
      <div className="card1 shadow m-1 mt-2 ">
        <div className="row m-1">
          <div className="col-xs-6 col-sm-4  col-lg-1 d-flex align-items-center">
            <span className="badge rounded-pill bg-secondary  ">1</span>
            <span className="badge rounded-pill bg-primary  ms-2">
              แก้ไขวัตถุประสงค์
            </span>
            <div
              className="text-primary"
              style={{ fontSize: 16, fontWeight: "bold" }}
            />
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <h6>
                สาขา :<small style={{ fontSize: 14 }}> โรงชิพวัฒนานคร</small>{" "}
              </h6>
            </div>
            <div>
              <h6>
                เลขที่ใบงาน :
                <small style={{ fontSize: 14 }}> 529-651190785</small>
              </h6>
            </div>
            <div />
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <h6>
                ประเภทลูกค้า :
                <small style={{ fontSize: 14 }}> ลูกค้าทั่วไป</small>
              </h6>
            </div>
            <div>
              <h6>
                ชื่อลูกค้า :<small style={{ fontSize: 14 }}> โรงไฟฟ้า 9</small>
              </h6>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <div>
                <h6>
                  วันที่บันทึก :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:20:23</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้ทำรายการ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-1">
            <span>ข้อมูล</span>
            <div style={{ fontSize: 14 }}>
              <span
                className="badge bg-success"
                style={{ fontSize: 14, cursor: "pointer" }}
              >
                1
              </span>
              <span className="badge badge text-dark">
                {" "}
                <span style={{ fontSize: 14, cursor: "pointer" }} />
              </span>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2 col-lg-3">
            <div>
              <div>
                <h6>
                  วันที่อนุมัติ :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:21:20</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้อนุมัติ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                  <span className="badge rounded-pill bg-success  ms-2">
             <span className=" mx-2 ">อนุมัติแล้ว</span> 
            </span>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2 col-lg-1  d-flex align-items-center d-flex justify-content-end">
          {/* <span className="text-primary  ">สถานะ</span> */}
            
            <span className="badge rounded-pill text-primary fs-5">
            <i className="bi bi-pencil-square"  style={{ cursor: "pointer" }}></i>
            </span>
          </div>
        </div>
      </div>
      <div className="card1 shadow m-1 mt-2 ">
        <div className="row m-1">
          <div className="col-xs-6 col-sm-4  col-lg-1 d-flex align-items-center">
            <span className="badge rounded-pill bg-secondary  ">1</span>
            <span className="badge rounded-pill bg-primary  ms-2">
              แก้ไขวัตถุประสงค์
            </span>
            <div
              className="text-primary"
              style={{ fontSize: 16, fontWeight: "bold" }}
            />
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <h6>
                สาขา :<small style={{ fontSize: 14 }}> โรงชิพวัฒนานคร</small>{" "}
              </h6>
            </div>
            <div>
              <h6>
                เลขที่ใบงาน :
                <small style={{ fontSize: 14 }}> 529-651190785</small>
              </h6>
            </div>
            <div />
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <h6>
                ประเภทลูกค้า :
                <small style={{ fontSize: 14 }}> ลูกค้าทั่วไป</small>
              </h6>
            </div>
            <div>
              <h6>
                ชื่อลูกค้า :<small style={{ fontSize: 14 }}> โรงไฟฟ้า 9</small>
              </h6>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-2">
            <div>
              <div>
                <h6>
                  วันที่บันทึก :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:20:23</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้ทำรายการ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4  col-lg-1">
            <span>ข้อมูล</span>
            <div style={{ fontSize: 14 }}>
              <span
                className="badge bg-success"
                style={{ fontSize: 14, cursor: "pointer" }}
              >
                1
              </span>
              <span className="badge badge text-dark">
                {" "}
                <span style={{ fontSize: 14, cursor: "pointer" }} />
              </span>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2 col-lg-3">
            <div>
              <div>
                <h6>
                  วันที่อนุมัติ :
                  <small style={{ fontSize: 14 }}> 2022-11-30 13:21:20</small>
                </h6>
              </div>
            </div>
            <div>
              <div>
                <h6>
                  ผุ้อนุมัติ :
                  <small style={{ fontSize: 14 }}> รุ่งอรวรรณ จารุนัย</small>
                  <span className="badge rounded-pill bg-warning text-dark ms-2">
             <span className=" mx-2 ">รออนุมัติ</span> 
            </span>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2 col-lg-1  d-flex align-items-center d-flex justify-content-end">
            <span className="badge rounded-pill text-primary fs-5">
            <i className="bi bi-pencil-square"  style={{ cursor: "pointer" }}></i>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Myregister;
